export default "__VITE_ASSET__0F8qrDDo__"